"use client";

import React from "react";
import { Twitter, Linkedin, MapPin, Loader, Phone, Mail, ExternalLink } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        <div className="h-4 w-24 bg-muted/50 animate-pulse rounded-md" />
        <div className="h-4 w-32 bg-muted/50 animate-pulse rounded-md" />
        <div className="h-4 w-20 bg-muted/50 animate-pulse rounded-md" />
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium font-mono">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Twitter,
    href: "https://x.com/DavidLinthicum",
    label: "X"
  }, {
    icon: Linkedin,
    href: "https://www.linkedin.com/in/davidlinthicum/",
    label: "LinkedIn"
  }];
  return <section data-section-id="265098" id="footer" className="bg-background text-foreground pt-16 pb-8 px-6 md:px-12 border-t border-border/40">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="inline-block">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <div className="space-y-4 text-sm text-muted-foreground font-default">
              <p className="leading-relaxed">
                Architecting the future of Cloud and AI. David Scott Linthicum provides visionary leadership for global tech transformation.
              </p>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-bold font-default text-foreground tracking-tighter uppercase">Navigation</h3>
            <MenuProvider menu_id="46">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-bold font-default text-foreground tracking-tighter uppercase">Consultation</h3>
            <div className="flex flex-col gap-3">
              <Link to="mailto:david@davidlinthicum.com" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors text-sm font-medium font-mono">
                <Mail className="size-4" />
                david@davidlinthicum.com
              </Link>
              <Link to="tel:+1(703)216-6676" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors text-sm font-medium font-mono">
                <Phone className="size-4" />
                +1 (703) 216-6676
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mb-16 p-8 rounded-lg border border-border/40 bg-muted/10 backdrop-blur-sm flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="space-y-2 text-center md:text-left">
            <h3 className="text-2xl font-bold tracking-tighter text-foreground">Subscribe to Our Newsletter</h3>
            <p className="text-muted-foreground max-w-md">
              Get the latest insights on Cloud Computing and AI transformation delivered directly to your professional network.
            </p>
          </div>
          <Link to="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7412852637571825666" newTab>
            <Button variant="secondary" size="lg" className="font-bold uppercase tracking-wider">
              Subscribe to David's Newsletter on LinkedIn
              <ExternalLink className="ml-2 size-4" />
            </Button>
          </Link>
        </div>

        {}
        <div className="pt-8 border-t border-border/40 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-muted-foreground font-mono">
            <span>&copy; {new Date().getFullYear()} David Scott Linthicum. All rights reserved.</span>
          </div>
          
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-muted/20 border border-border/50 text-xs font-medium text-muted-foreground font-mono backdrop-blur-sm">
            <MapPin className="size-3.5 text-primary" />
            Cloud Native & AI Driven
          </div>

          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} data-index={i} className="text-muted-foreground hover:text-primary transition-all hover:drop-shadow-[0_0_8px_rgba(0,255,255,0.6)]" aria-label={social.label}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </section>;
}